import React from 'react';
import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function useUserInfo() {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['userInfo'],
    queryFn: async () => await (await glynt).org.userInfo(),
    refetchOnWindowFocus: false
  });
}
